import './vendor';
import './helpers';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import analytics from './components/analytics';
import slider from './components/slider';
import player from './components/player';
import popup from './components/popup';
import dropdown from './components/dropdown';
import share from './components/share';
import {loadSite} from './components/load-site';
import animationStart from './components/animations/animationStart';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';

loadSite().then(() => {
	ieFix();
	vhFix();
	actualYear();
	analytics.init();
	slider.init();
	lazyLoading.init();
	share.init(document);

	animationStart.init(document).then(() => {
		scrollToAnchor.init();
		dropdown.init();
		player.init($(document));
		popup.init(document);
	});
});
